/**
 * SportsCategoryPage — /sports/categories
 *
 * Renders the full taxonomy (from /api/sports/meta) as grouped
 * chip sections. Clicking a sport jumps to the tournaments listing
 * filtered by that sport.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, ArrowRight } from "lucide-react";
import { http } from "@/lib/api";
import SportsCategoryNav from "@/components/SportsCategoryNav";

export default function SportsCategoryPage() {
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    http.get("/sports/meta").then(r => setMeta(r.data)).catch(() => setMeta({ categories: [] }));
  }, []);

  return (
    <>
      <SportsCategoryNav />
      <div className="max-w-6xl mx-auto px-4 py-8" data-testid="sports-category-page">
        <div className="mb-6">
          <div className="overline mb-1">CATEGORIES</div>
          <h1 className="font-display text-4xl mb-2">Every sport, one place</h1>
          <p className="opacity-70 max-w-2xl">
            From cricket and football to kalaripayattu and mallakhamb — tap any sport
            to browse tournaments and teams in that discipline.
          </p>
        </div>

        {!meta ? (
          <div className="opacity-60 text-sm">Loading…</div>
        ) : (
          <div className="space-y-8">
            {meta.categories.map(cat => (
              <section key={cat.key} data-testid={`category-${cat.key}`}>
                <h2 className="font-display text-2xl mb-3">{cat.label}</h2>
                <div className="flex flex-wrap gap-2">
                  {cat.sports.map(s => (
                    <Link key={s.slug} to={`/sports/tournaments?sport=${s.slug}`}
                      className="inline-flex items-center gap-1.5 text-sm px-3 py-1.5 rounded-full border hover:bg-black/5 transition"
                      style={{ borderColor: "var(--wofy-border)" }}
                      data-testid={`category-sport-${s.slug}`}>
                      <Trophy className="w-3.5 h-3.5" />{s.label}
                      <ArrowRight className="w-3 h-3 opacity-50" />
                    </Link>
                  ))}
                </div>
              </section>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
